import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Creator Management Bajwa Co</title>
        <meta property="og:title" content="Creator Management Bajwa Co" />
        <link
          rel="canonical"
          href="https://infatuated-serene-kookabura-ii1j4j.teleporthq.app/"
        />
        <meta
          property="og:url"
          content="https://infatuated-serene-kookabura-ii1j4j.teleporthq.app/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-business">
        <div className="hero-bg">
          <img
            alt="Abstract Green Flow"
            src="https://images.pexels.com/photos/36025194/pexels-photo-36025194.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-bg-img"
          />
          <div id="home" className="hero-overlay"></div>
        </div>
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-avatar-wrapper">
              <div className="hero-avatar-circle">
                <div className="home-thq-hero-avatar-img-elm hero-avatar-img">
                  <div className="home-container2">
                    <div className="home-container3">
                      <img
                        alt="image"
                        src="/bajwa%20co.1-200h.png"
                        className="home-image1"
                      />
                    </div>
                  </div>
                </div>
                <img
                  alt="image"
                  src="/bajwa-co-logo-200h.jpg"
                  className="home-image2"
                />
                <img
                  alt="image"
                  src="/bajwa-co-logo-200h.jpg"
                  className="home-image3"
                />
              </div>
            </div>
            <h1 className="hero-title home-hero-title">
              I Handle the Business. You Focus on Creating.
            </h1>
            <p className="home-hero-subtitle hero-subtitle">
              Friendly, authentic, and professional creator management that
              scales your influence without the burnout.
            </p>
            <div className="hero-benefits">
              <div className="hero-benefit-item">
                <div className="hero-benefit-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0"></path>
                      <path d="M7 12a5 5 0 1 0 10 0a5 5 0 1 0-10 0"></path>
                      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0"></path>
                    </g>
                  </svg>
                </div>
                <span className="hero-benefit-text">Finds sponsors</span>
              </div>
              <div className="hero-benefit-item">
                <div className="hero-benefit-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <span className="hero-benefit-text">Handles contracts</span>
              </div>
              <div className="hero-benefit-item">
                <div className="hero-benefit-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <span className="hero-benefit-text">Paid only on results</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="what-i-do">
        <div className="wid-container">
          <h2 className="section-title wid-title">What I Do</h2>
          <div className="wid-grid">
            <div className="wid-card">
              <div className="wid-card-visual">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0"></path>
                    <path d="M7 12a5 5 0 1 0 10 0a5 5 0 1 0-10 0"></path>
                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0"></path>
                  </g>
                </svg>
              </div>
              <h3 className="wid-card-title">Find Sponsors</h3>
              <p className="section-content">
                I hunt down the brands that actually align with your audience
                and values.
              </p>
            </div>
            <div className="wid-card">
              <div className="wid-card-visual">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="wid-card-title">Handle Paperwork</h3>
              <p className="section-content">
                No more legal jargon. I manage contracts so you stay protected
                and focused.
              </p>
            </div>
            <div className="wid-card">
              <div className="wid-card-visual">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m11 17l2 2a1 1 0 1 0 3-3"></path>
                    <path d="m14 14l2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"></path>
                    <path d="m21 3l1 11h-2M3 3L2 14l6.5 6.5a1 1 0 1 0 3-3M3 4h8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="wid-card-title">Close Deals</h3>
              <p className="section-content">
                Negotiating the highest possible rates so you never leave money
                on the table.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="how" className="how-it-works">
        <div className="hiw-container">
          <h2 className="section-title hiw-title">How It Works</h2>
          <div className="hiw-steps">
            <div className="hiw-step">
              <div className="hiw-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227q1.63.24 3.293.369V21l4.076-4.076a1.53 1.53 0 0 1 1.037-.443a48 48 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.4 48.4 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="hiw-step-content">
                <h3 className="section-subtitle">We Chat</h3>
                <p className="section-content">
                  A quick call to understand your brand and goals.
                </p>
              </div>
            </div>
            <div className="hiw-step-divider"></div>
            <div className="hiw-step">
              <div className="hiw-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="hiw-step-content">
                <h3 className="section-subtitle">I Find Deals</h3>
                <p className="section-content">
                  I reach out to my network and secure partnerships.
                </p>
              </div>
            </div>
            <div className="hiw-step-divider"></div>
            <div className="hiw-step">
              <div className="hiw-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"></path>
                    <path d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2m5 6h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H10m2 0v1m0-8v1"></path>
                  </g>
                </svg>
              </div>
              <div className="hiw-step-content">
                <h3 className="section-subtitle">You Get Paid</h3>
                <p className="section-content">
                  Revenue hits your bank. I take a small cut.
                </p>
              </div>
            </div>
          </div>
          <div className="hiw-pricing">
            <p className="section-content">
              <span className="home-text1">10–20% cut.</span>
              <span> No upfront cost. Zero risk.</span>
            </p>
          </div>
        </div>
      </section>
      <section id="why" className="why">
        <div className="why-container">
          <h2 className="section-title why-title">Why Me?</h2>
          <div className="why-grid">
            <div className="why-item">
              <div className="why-item-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.414 14.414C21 12.828 22 11.5 22 9.5a5.5 5.5 0 0 0-9.591-3.676a.6.6 0 0 1-.818.001A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.535 5.362a2 2 0 0 0 2.879.052a2.12 2.12 0 0 0-.004-3a2.124 2.124 0 1 0 3-3a2.124 2.124 0 0 0 3.004 0a2 2 0 0 0 0-2.828l-1.881-1.882a2.41 2.41 0 0 0-3.409 0l-1.71 1.71a2 2 0 0 1-2.828 0a2 2 0 0 1 0-2.828l2.823-2.762"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="why-item-text">
                <h3 className="section-subtitle">Authentic</h3>
                <p className="section-content">
                  I treat your brand like my own. No shady deals, just real
                  growth.
                </p>
              </div>
            </div>
            <div className="why-item">
              <div className="why-item-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594zM20 2v4m2-2h-4"></path>
                    <circle r="2" cx="4" cy="20"></circle>
                  </g>
                </svg>
              </div>
              <div className="why-item-text">
                <h3 className="section-subtitle">Hardworking</h3>
                <p className="section-content">
                  I don&apos;t stop until the contract is signed and the payment
                  is secured.
                </p>
              </div>
            </div>
            <div className="why-item">
              <div className="why-item-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-5l-5 3v-3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM9.5 9h.01m4.99 0h.01"></path>
                    <path d="M9.5 13a3.5 3.5 0 0 0 5 0"></path>
                  </g>
                </svg>
              </div>
              <div className="why-item-text">
                <h3 className="section-subtitle">Easy to Reach</h3>
                <p className="section-content">
                  I&apos;m always a text or call away. Communication is my top
                  priority.
                </p>
              </div>
            </div>
            <div className="why-item">
              <div className="why-item-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="why-item-text">
                <h3 className="section-subtitle">Does Heavy Lifting</h3>
                <p className="section-content">
                  I manage the boring business bits so you can stay in your
                  creative flow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="quick-stats">
        <div className="stats-container">
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number">0</span>
              <span className="stat-label">Deals Closed</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">$0+</span>
              <span className="stat-label">Value Negotiated</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">0</span>
              <span className="stat-label">Creators Represented</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Trust Score</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Support Access</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">0</span>
              <span className="stat-label">Upfront Fees</span>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials">
        <div className="test-container">
          <h2 className="test-title section-title">What Creators Say</h2>
          <div id="testimonialCarousel" className="test-carousel">
            <div className="test-track">
              <div className="test-card">
                <div className="test-avatar">
                  <img
                    alt="Creator Avatar"
                    src="https://images.pexels.com/photos/16036148/pexels-photo-16036148.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    className="test-avatar-img"
                  />
                </div>
                <p className="section-content test-quote">&quot;&quot;</p>
                <span className="test-author">— </span>
              </div>
              <div className="test-card">
                <div className="test-avatar">
                  <img
                    alt="Creator Avatar"
                    src="https://images.pexels.com/photos/16042675/pexels-photo-16042675.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    className="test-avatar-img"
                  />
                </div>
                <p className="section-content test-quote">&quot;&quot;</p>
                <span className="test-author">— </span>
              </div>
              <div className="test-card">
                <div className="test-avatar">
                  <img
                    alt="Creator Avatar"
                    src="https://images.pexels.com/photos/12198523/pexels-photo-12198523.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    className="test-avatar-img"
                  />
                </div>
                <p className="section-content test-quote">&quot;&quot;</p>
                <span className="test-author">— </span>
              </div>
            </div>
            <div className="test-controls">
              <button aria-label="Previous" className="test-btn prev">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m15 18l-6-6l6-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </button>
              <button aria-label="Next" className="test-btn next">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m9 18l6-6l-6-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" className="contact-section">
        <div className="contact-container">
          <div className="contact-card">
            <div className="contact-header">
              <div className="contact-avatar">
                <div className="home-thq-contact-avatar-img-elm contact-avatar-img">
                  <img
                    alt="image"
                    src="https://raw.githubusercontent.com/mussaw1r/bajwaco/refs/heads/main/minilogo2.png"
                    className="home-image4"
                  />
                </div>
              </div>
              <h2 className="section-title">Let&apos;s Build Your Legacy</h2>
            </div>
            <div className="contact-info">
              <div className="contact-method">
                <span className="contact-label">Email</span>
                <a href="mailto:hi@bajwaco.com?subject=">
                  <div className="contact-value">
                    <span>hi@bajwaco.com</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="contact-actions">
              <a
                href="https://mail.google.com/mail/u/0/?fs=1&amp;tf=cm&amp;to=hi@bajwaco.com&amp;su=About+Creator+Manager&amp;body=Hi+Bajwa Co, "
                target="_blank"
                rel="noreferrer noopener"
              >
                <div className="home-thq-btn-elm btn btn-xl btn-primary">
                  <span>Click to Email Now</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<style>
section {
  position: relative;
  overflow: hidden;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="home-container6">
        <div className="home-container7">
          <Script
            html={`<script defer data-name="testimonial-carousel">
(function(){
  const track = document.querySelector('.test-track');
  const cards = document.querySelectorAll('.test-card');
  const nextBtn = document.querySelector('.test-btn.next');
  const prevBtn = document.querySelector('.test-btn.prev');
  
  let currentIndex = 0;

  function updateCarousel() {
    const cardWidth = cards[0].offsetWidth;
    const gap = parseInt(getComputedStyle(track).gap);
    const offset = currentIndex * (cardWidth + gap);
    track.style.transform = \`translateX(-\${offset}px)\`;
  }

  nextBtn.addEventListener('click', () => {
    const visibleCards = window.innerWidth > 991 ? 3 : (window.innerWidth > 767 ? 2 : 1);
    if (currentIndex < cards.length - visibleCards) {
      currentIndex++;
    } else {
      currentIndex = 0;
    }
    updateCarousel();
  });

  prevBtn.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
    } else {
      const visibleCards = window.innerWidth > 991 ? 3 : (window.innerWidth > 767 ? 2 : 1);
      currentIndex = cards.length - visibleCards;
    }
    updateCarousel();
  });

  window.addEventListener('resize', () => {
    currentIndex = 0;
    updateCarousel();
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
